module.exports = __webpack_public_path__ + "img/3-5.837c063c.png";